import styled, { css } from 'styled-components'
import { Button } from '@material-ui/core'
import { colors } from '../../styles'

export const StyledButton = styled(Button)`
  cursor: pointer;
  box-shadow: none;
  border-radius: 0;
  text-transform: none;
  padding: 8px 40px;
`

export const StyledSwitcher = styled.div`
  border: 1px solid ${colors.green};
  border-radius: 5px;
  display: inline-block;
  margin: 16px 0;
`

export const StyledSwitchContent = styled.div`
  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}
`
